import React from 'react';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import './PriceDetails.styles.scss';

const fmt = (n) => (n === 0 ? 'Free' : `₹${n}`);

const PriceDetails = ({ applicationFee, cscCharge, total, categoryLabel }) => {
  return (
    <div className="price-details">
      <h2>
        <CurrencyRupeeIcon className="price-details__icon" />
        Price Details
      </h2>

      <div className="price-details__category">
        <span className="price-details__category-label">Your Category</span>
        <span className="price-details__category-badge">{categoryLabel || 'General / UR'}</span>
      </div>

      <div className="price-item">
        <p>Application Fee</p>
        <p>{fmt(applicationFee)}</p>
      </div>
      <div className="price-item">
        <p>CSC Processing Charge</p>
        <p>{fmt(cscCharge)}</p>
      </div>
      <div className="price-item">
        <p>Platform Fee</p>
        <p>₹0</p>
      </div>
      <div className="price-item">
        <p>Total Amount</p>
        <p>{total === 0 ? 'Free' : `₹${total}`}</p>
      </div>
    </div>
  );
};

export default PriceDetails;
